import { render, staticRenderFns } from "./OperateModelDialog.vue?vue&type=template&id=6ffb4a74&scoped=true"
import script from "./OperateModelDialog.vue?vue&type=script&lang=js"
export * from "./OperateModelDialog.vue?vue&type=script&lang=js"
import style0 from "./OperateModelDialog.vue?vue&type=style&index=0&id=6ffb4a74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb4a74",
  null
  
)

export default component.exports